import React from "react";

export default function ReportButton({ 
  icon, 
  reportName, 
  onClick, 
  ariaLabel = "Report Button" 
}) {
  return (
    <button
      onClick={onClick}
      className="w-full inline-flex items-center justify-between px-4 py-3 bg-white border border-gray-200 rounded-sm hover:bg-gray-50 hover:border-gray-300 transition-colors duration-200 group"
      aria-label={ariaLabel}
    >
      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0 text-gray-400 group-hover:text-gray-500">
          {icon}
        </div>
        <span className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
          {reportName}
        </span>
      </div>
      <svg
        className="h-5 w-5 text-gray-400 group-hover:text-gray-500"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
          clipRule="evenodd"
        />
      </svg>
    </button>
  );
}
